import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, saveSession } from "@/lib/api";
import Navbar from "@/components/karmivo/Navbar";
import GoogleButton from "@/components/karmivo/GoogleButton";

export default function CustomerLogin() {
  const nav = useNavigate();
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async () => {
    setLoading(true);
    try {
      const { data } = await api.post(`/auth/login`, { phone, password, role: "customer" });
      saveSession("customer", data);
      toast.success("Welcome back"); nav("/");
    } catch (e) { toast.error(e.response?.data?.detail || "Login failed"); }
    finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen bg-slate-50"><Navbar/>
      <div className="max-w-md mx-auto px-6 py-16">
        <Card className="p-6">
          <h1 className="font-display text-2xl font-bold text-slate-900">Customer Login</h1>
          <p className="text-sm text-slate-500">Access your bookings & complaints.</p>
          <div className="mt-5">
            <GoogleButton/>
            <div className="my-5 flex items-center gap-3 text-xs text-slate-400">
              <div className="flex-1 h-px bg-slate-200"/><span>or with phone</span><div className="flex-1 h-px bg-slate-200"/>
            </div>
          </div>
          <div className="space-y-3">
            <div><Label>Phone</Label><Input value={phone} onChange={e => setPhone(e.target.value)} data-testid="login-phone"/></div>
            <div><Label>Password</Label><Input type="password" value={password} onChange={e => setPassword(e.target.value)} data-testid="login-password"/></div>
            <Button className="w-full bg-orange-500 hover:bg-orange-600" onClick={submit} disabled={loading} data-testid="login-submit">Login</Button>
            <p className="text-xs text-slate-500 text-center">No account? <Link to="/customer/register" className="text-orange-600 font-semibold" data-testid="link-register">Register</Link></p>
          </div>
        </Card>
      </div>
    </div>
  );
}
